import React from "react";
import { API_URL, getCurrentEnvironment } from "../../constants/api";
import { apiRequest, apiPut } from "../../utils/api_service";
import { validateInput } from "../../utils/validations";
import { ShowToast, toastType } from "../../utils/toast-service";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  TextareaAutosize,
  Toolbar,
  Typography,
} from "@material-ui/core";
import LabelWithSelect from "../common/selectWithLabel/selectWithLabel";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { IsTenant } from "../../utils/helper";
import "./requests.less";
import uniqBy from "lodash/uniqBy";
import { convertIntoDDFormat } from "../../utils/generic";
import {
  BADGE_TYPE,
  REQUEST_STATUS,
  REQUEST_TYPE,
} from "../../constants/appConstants";
import moment from "moment";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";

class ResponseToRequest extends React.Component {
  constructor(props) {
    super(props);
    const {
      requestId,
      requestCode,
      requestType,
      requestTypeId,
      badgeTypeId,
      newGrantAccessProcess
    } = props.requestData;
    this.state = {
      requestId: requestId,
      requestCode: requestCode,
      requestType: requestType,
      requestTypeId: requestTypeId,
      badgeTypeId: badgeTypeId,
      responseDescription: "",
      selectedRequestStatusId:
        props.requestStatusId || REQUEST_STATUS.INPROGRESS,
      requestStatusId: IsTenant() ? props.requestStatusId :
        props.requestStatusId == REQUEST_STATUS.CREATED
          ? REQUEST_STATUS.INPROGRESS
          : props.requestStatusId || REQUEST_STATUS.INPROGRESS,
      requestStatusMaster: props.requestStatusMaster,
      getToolTip: props.getToolTip,
      badgeNumber: "",
      isNewGrantAccessProcess: newGrantAccessProcess
    };
  }
/**
 * Method to check if props changed
 * @param {*} newProps 
 * @param {*} state 
 * @returns 
 */
  static getDerivedStateFromProps(newProps, state) {
    const {
      requestId,
      requestCode,
      requestType,
      requestTypeId,
      badgeTypeId,
      newGrantAccessProcess
    } = newProps.requestData;
    if (requestId != state.requestId ||
      requestCode != state.requestCode ||
      requestType != state.requestType ||
      requestTypeId != state.requestTypeId ||
      badgeTypeId != state.badgeTypeId ||
      newGrantAccessProcess != state.newGrantAccessProcess
    ) {
      return {
        requestId: requestId,
        requestCode,
        requestType,
        requestTypeId,
        badgeTypeId,
        newGrantAccessProcess
      }
    }
    else {
      return state
    }

  }

  /**
   * Method is used to change state for given key
   * @param {*} key 
   * @param {*} value 
   */
  changeState = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  /**
   * Method to Get Request based on Request Type nad Id
   * @param {*} requestId 
   * @param {*} requestTypeId 
   */
  getCurrentRequest = (requestId, requestTypeId) => {
    apiRequest({
      url: API_URL.request.GetRequestDetailsByRequestType,
      params: { requestId: requestId, requestTypeId: requestTypeId },
    }).then(({ data: response }) => {
      if (!response) return;

      this.setState({
        responseDescription: response.ResponseDescription,
        requestStatusId: response.RequestStatusId,
        badgeNumber: response.BadgeNumber || ""
      });
    });
  };

  /**
   * Method to validate changes before post
   */
  handleSave = () => {
    const {
      requestId,
      responseDescription,
      requestTypeId,
      requestStatusId,
      selectedRequestStatusId,
      badgeNumber,
      isNewGrantAccessProcess
    } = this.state;

    const responseBody = {
      requestId: requestId,
      notes: responseDescription ? responseDescription.trim() + (badgeNumber ? `; Badge # ${badgeNumber.trim()}` : "") : "",
      requestTypeId: requestTypeId,
      requestStatusId:
        requestStatusId < REQUEST_STATUS.CREATED ? 0 : requestStatusId,
      environmentName: getCurrentEnvironment().environment,
      currentDateTimeOffset: moment().utcOffset(),
      uploadBRRDocument: selectedRequestStatusId !== REQUEST_STATUS.APPROVED,
      statusChangedToCompleted: selectedRequestStatusId != REQUEST_STATUS.COMPLETED,
      sendBRRFormEmailLink:
        selectedRequestStatusId == REQUEST_STATUS.ABRF_APPROVED &&
        requestStatusId == REQUEST_STATUS.WAITING_FOR_SIGNED_BRR,
      requestOldStatusId: selectedRequestStatusId,
      badgeNumber: badgeNumber ? badgeNumber.trim() : "",
      isTenant: IsTenant() 
    };

    const badgeNumberRequiredValidation = isNewGrantAccessProcess
      ? requestTypeId === REQUEST_TYPE.ACCESS_REQUEST && requestStatusId === REQUEST_STATUS.SECURITY_APPROVED && selectedRequestStatusId !== REQUEST_STATUS.SECURITY_APPROVED
      : requestTypeId === REQUEST_TYPE.ACCESS_REQUEST && requestStatusId === REQUEST_STATUS.COMPLETED && selectedRequestStatusId !== REQUEST_STATUS.COMPLETED

    const responseValidation = [
      {
        valueKey: "requestStatusId",
        type: "text",
        isRequired: true,
        fieldsName: "Request Status",
      },
      {
        valueKey: "badgeNumber",
        type: "text",
        isRequired: badgeNumberRequiredValidation,
        fieldsName: "Badge Number",
      },
      {
        valueKey: "notes",
        type: "text",
        isRequired: true,
        fieldsName: "Notes",
      }
    ];

    if (validateInput(responseBody, responseValidation)) {
      if (requestId) {
        this.responseToRequest(responseBody);
      }
    }
  };

  /**
   * Method for updating response to request
   * @param {*} params 
   */
  responseToRequest = (params) => {
    apiPut({
      url: API_URL.request.ResponseToRequest,
      postBody: params,
    }).then(({ data: response, success: success }) => {
      if (!success || response?.success == 0) {
        ShowToast(response.message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success) {
        ShowToast(
          "Response submitted Successfully",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.refreshRequest(true);
      } else {
        this.props.refreshRequest(false);
      }
    });
  };

  /**
   * Method for Handling Cancel event
   */
  handleCancel = () => {
    this.props.onClose(false);
    this.setState({
      requestCode: "",
      responseDescription: "",
      requestType: "",
      requestTypeId: null,
      requestStatusId: null,
    });
  };

  /**
   * Render response to request dialog box
   * @returns 
   */
  render() {
    const {
      requestCode,
      responseDescription,
      requestStatusId,
      selectedRequestStatusId,
      requestType,
      requestTypeId,
      requestStatusMaster,
      badgeTypeId,
      badgeNumber,
      isNewGrantAccessProcess
    } = this.state;

    let filteredRequestStatusMaster = [];
    if (IsTenant()) {
      filteredRequestStatusMaster = requestStatusMaster;
    }
    else {
      if (
        requestTypeId === REQUEST_TYPE.ACCESS_REQUEST &&
        badgeTypeId !== BADGE_TYPE.Visitor_Badge
      ) {
        let newRequestMaster = [];
        if (selectedRequestStatusId === REQUEST_STATUS.ABRF_APPROVED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.WAITING_FOR_SIGNED_BRR) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.AWAITING_FOR_ABRF) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.COMPLETED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.DENIED
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.APPROVED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.DENIED &&
                x.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.DENIED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.ENGINEERING_APPROVED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.COMPLETED
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.SECURITY_APPROVED) {
          newRequestMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.ENGINEERING_APPROVED
            ) || [];
        }
        else {
          if (isNewGrantAccessProcess) {
            newRequestMaster =
              requestStatusMaster.filter(
                (x) =>
                  x.RequestStatusId != REQUEST_STATUS.DRAFT &&
                  x.RequestStatusId != REQUEST_STATUS.SECURITY_APPROVED &&
                  x.RequestStatusId != REQUEST_STATUS.COMPLETED
              ) || [];
          }
          else
            newRequestMaster = requestStatusMaster;
        }

        filteredRequestStatusMaster =
          newRequestMaster?.filter(
            (rs) => rs.RequestStatusId > REQUEST_STATUS.CREATED
          ) || [];
      } else {
        /** show InProgress, Approved, Denied Status */
        if (selectedRequestStatusId === REQUEST_STATUS.DENIED) {
          filteredRequestStatusMaster =
            requestStatusMaster.filter(
              (rs) =>
                rs.RequestStatusId != REQUEST_STATUS.DRAFT &&
                rs.RequestStatusId != REQUEST_STATUS.CREATED &&
                rs.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                rs.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                rs.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                rs.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                rs.RequestStatusId != REQUEST_STATUS.APPROVED
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.APPROVED) {
          filteredRequestStatusMaster =
            requestStatusMaster.filter(
              (rs) =>
                rs.RequestStatusId != REQUEST_STATUS.DRAFT &&
                rs.RequestStatusId != REQUEST_STATUS.CREATED &&
                rs.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                rs.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                rs.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                rs.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                rs.RequestStatusId != REQUEST_STATUS.DENIED
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.ENGINEERING_APPROVED) {
          filteredRequestStatusMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.COMPLETED &&
                x.RequestStatusId != REQUEST_STATUS.DRAFT
            ) || [];
        }
        else if (selectedRequestStatusId === REQUEST_STATUS.SECURITY_APPROVED) {
          filteredRequestStatusMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.ENGINEERING_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.DRAFT
            ) || [];
        }

        else if (selectedRequestStatusId === REQUEST_STATUS.COMPLETED) {
          filteredRequestStatusMaster =
            requestStatusMaster.filter(
              (x) =>
                x.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                x.RequestStatusId != REQUEST_STATUS.INPROGRESS &&
                x.RequestStatusId != REQUEST_STATUS.APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.DENIED &&
                x.RequestStatusId != REQUEST_STATUS.SECURITY_APPROVED &&
                x.RequestStatusId != REQUEST_STATUS.ENGINEERING_APPROVED
            ) || [];
        }

        else {
          if (isNewGrantAccessProcess) {
            filteredRequestStatusMaster =
              requestStatusMaster?.filter(
                (rs) =>
                  rs.RequestStatusId != REQUEST_STATUS.DRAFT &&
                  rs.RequestStatusId != REQUEST_STATUS.CREATED &&
                  rs.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                  rs.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                  rs.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                  rs.RequestStatusId != REQUEST_STATUS.SECURITY_APPROVED &&
                  rs.RequestStatusId != REQUEST_STATUS.COMPLETED
              ) || [];
          }
          else {
            filteredRequestStatusMaster =
              requestStatusMaster?.filter(
                (rs) =>
                  rs.RequestStatusId != REQUEST_STATUS.DRAFT &&
                  rs.RequestStatusId != REQUEST_STATUS.CREATED &&
                  rs.RequestStatusId != REQUEST_STATUS.WAITING_FOR_SIGNED_BRR &&
                  rs.RequestStatusId != REQUEST_STATUS.ABRF_APPROVED &&
                  rs.RequestStatusId != REQUEST_STATUS.AWAITING_FOR_ABRF &&
                  rs.RequestStatusId != REQUEST_STATUS.SECURITY_APPROVED
              ) || [];
          }
        }
      }
    }


    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          //onClose={() => this.props.onClose(false)}
          //PaperComponent={PaperComponent}
          fullWidth
          maxWidth={"md"}
          className={"response-to-request"}
          aria-labelledby={"confirmation-dialog-title"}
          handleCancel={() => this.props.onClose(false)}
          disableBackdropClick
        >
          <AppBar id={"confirmation-dialog-title"} style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {"Respond To Request"}
              </Typography>
              <IconButton
                edge={"end"}
                color={"inherit"}
                onClick={() => this.props.onClose(false)}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent>
            <Box
              component={"form"}
              border={0}
              borderColor={"grey.500"}
              borderRadius={1}
              noValidate
              autoComplete={"off"}
            >
              <div className={"row"}>
                <div className={"col-xs-6 col-md-6 col-lg-4"}>
                  <TextFieldWithToolTip
                    id={"requestCode"}
                    txtName={"requestCode"}
                    labelHeading={"Request #"}
                    value={requestCode || ""}
                    disabled
                    toolTip={
                      this.state.getToolTip?.find(
                        (b) => b.UiColumnName == "Request #"
                      )?.Tooltip
                    }
                  />
                </div>
                <div className={"col-xs-6 col-md-6 col-lg-4"}>
                  <TextFieldWithToolTip
                    fullWidth
                    id={"requestType"}
                    txtName={"requestType"}
                    labelHeading={"Request Type"}
                    value={requestType || ""}
                    disabled
                    toolTip={
                      this.state.getToolTip?.find(
                        (b) => b.UiColumnName == "Request Type"
                      )?.Tooltip
                    }
                  />
                </div>
                <div className={"col-xs-12 col-md-6 col-lg-4"}>
                  <LabelWithSelect
                    className={"box-style"}
                    keyValue={"requestStatusId"}
                    labelHeading={"Request Status"}
                    optionsList={uniqBy(
                      convertIntoDDFormat(
                        filteredRequestStatusMaster || [],
                        "RequestStatusId",
                        "RequestStatus"
                      ),
                      (x) => x.id
                    )}
                    selectedId={requestStatusId}
                    onChange={this.changeState}
                    disabled={
                      selectedRequestStatusId === REQUEST_STATUS.EXPIRED ||
                      selectedRequestStatusId === REQUEST_STATUS.DENIED ||
                      selectedRequestStatusId === REQUEST_STATUS.COMPLETED ||
                      IsTenant()
                    }
                    toolTip={
                      this.state.getToolTip?.find(
                        (b) => b.UiColumnName == "Request Status"
                      )?.Tooltip
                    }
                  />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-xs-6 col-md-6 col-lg-4"}>
                  {
                    ((isNewGrantAccessProcess && requestTypeId === REQUEST_TYPE.ACCESS_REQUEST && requestStatusId == REQUEST_STATUS.SECURITY_APPROVED && selectedRequestStatusId !== REQUEST_STATUS.SECURITY_APPROVED)
                      || (!isNewGrantAccessProcess && requestTypeId === REQUEST_TYPE.ACCESS_REQUEST && requestStatusId == REQUEST_STATUS.COMPLETED && selectedRequestStatusId !== REQUEST_STATUS.COMPLETED)) ?
                      (
                        <TextFieldWithToolTip
                          id={"badgeNumber"}
                          txtName={"badgeNumber"}
                          labelHeading={"Badge Number"}
                          value={badgeNumber || ""}
                          isRequired
                          toolTip={
                            this.state.getToolTip?.find(
                              (b) => b.UiColumnName == "Badge Number"
                            )?.Tooltip
                          }
                          onChange={(e) =>
                            this.changeState("badgeNumber", e.target.value)}
                        />
                      )
                      :
                      <></>
                  }
                </div>
              </div>
              <div className={"row"} style={{ paddingTop: "1%" }}>
                <div className={"col-xs-12"}>
                  <InputLabelWithToolTip
                    id={"noteLabel"}
                    labelHeading={"Note"}
                    disabled={false}
                    isRequired
                    toolTip={
                      this.state.getToolTip?.find(
                        (b) => b.UiColumnName == "Note"
                      )?.Tooltip
                    }
                  />
                  <TextareaAutosize
                    id={"responseDescription"}
                    name={"responseDescription"}
                    //label="Note"
                    placeholder={"Note"}
                    type={"text"}
                    value={responseDescription || ""}
                    variant={"standard"}
                    rowsMin={4}
                    rowsMax={4}
                    className={"multiline-text-box"}
                    onChange={(e) =>
                      this.changeState("responseDescription", e.target.value)}
                  />
                </div>
              </div>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleCancel} variant={"contained"}>
              {"Cancel\r"}
            </Button>
            <Button autoFocus onClick={this.handleSave} variant={"contained"}>
              {"Submit\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default ResponseToRequest;
